import { GAME_CACHE_TAGS } from '../tags';
import { apiBaseQuery } from '../../api/services/rtkQuery/apiBaseQuery';
import { getGameRoomsQuery, getInitGameQuery, getFavGamesQuery } from './queries';
export var gamesApi = apiBaseQuery.injectEndpoints({
  endpoints: function endpoints(builder) {
    return {
      getGameRooms: builder.query(getGameRoomsQuery),
      getInitGame: builder.query(getInitGameQuery),
      getFavGames: builder.query(getFavGamesQuery)
    };
  }
});
gamesApi.enhanceEndpoints({
  addTagTypes: GAME_CACHE_TAGS.gamesTagsArray
});
var useLazyGetFavGamesQuery = gamesApi.useLazyGetFavGamesQuery,
  useLazyGetGameRoomsQuery = gamesApi.useLazyGetGameRoomsQuery,
  _gamesApi$endpoints = gamesApi.endpoints,
  getGameRooms = _gamesApi$endpoints.getGameRooms,
  getInitGame = _gamesApi$endpoints.getInitGame,
  getFavGames = _gamesApi$endpoints.getFavGames;
export { useLazyGetFavGamesQuery, useLazyGetGameRoomsQuery, getGameRooms, getInitGame, getFavGames };